import useIsAuth from "@/utils/queries/hooks/useIsAuth";
import { ReactElement } from "react";
import LoaderPage from "./LoaderPage";

const AuthProvider = ({ children }: { children: ReactElement }) => {
    const isAuth = useIsAuth();
    return isAuth ? (
        children
    ) : (
        <div style={{ height: "100vh" }}>
            <LoaderPage loading />
        </div>
    );
};

export default AuthProvider;
